import type { CascadeOption } from '@byecode/ui'
import { CascadeSelect, Group, Text } from '@byecode/ui'
import { Card, Grid, Title } from '@mantine/core'
import React from 'react'

import { Unit } from '../Mics'

const options: CascadeOption[] = [
    {
        value: 'fruit',
        label: '水果1111111113123123123',
        children: [
            {
                value: 'apple',
                label: '苹果'
            },
            {
                value: 'banana',
                label: '香蕉'
            }
        ]
    },
    {
        value: 'vegetable',
        label: '蔬菜',
        children: [
            {
                value: 'tomato',
                label: '西红柿'
            },
            {
                value: 'potato',
                label: '土豆'
            }
        ]
    },
    {
        value: 'test',
        label: 'test'
    },
    {
        value: 'test1',
        label: 'test1'
    },
    {
        value: 'test2',
        label: 'test2'
    },
    {
        value: 'test3',
        label: 'test3'
    },
    {
        value: 'test4',
        label: 'test4'
    },
    {
        value: 'test5',
        label: 'test5'
    },
    {
        value: 'test6',
        label: 'test6'
    },
    {
        value: 'test7',
        label: 'test7'
    }
]

export const CascadeComponentsDemo: React.FC = () => {
    return (
        <Card withBorder>
            <Group label={<Title order={2}>级联选择</Title>} renderRightIcon={() => null}>
                <Grid gutter={20}>
                    <Grid.Col span={2}>
                        <Unit title="单选，选择任意层级">
                            <CascadeSelect popoverWidth={600} withinPortal selectionMode="any" options={options} />
                        </Unit>
                        <Unit title="多选,选择任意层级">
                            <CascadeSelect
                                popoverWidth={600}
                                allSelected
                                withinPortal
                                selectionMode="any"
                                searchable
                                multiple
                                options={options}
                            />
                        </Unit>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Unit title="单选，自动选树叶层级">
                            <CascadeSelect popoverWidth={600} withinPortal selectionMode="auto-leaf" options={options} />
                        </Unit>
                        <Unit title="多选,自动选树叶层级">
                            <CascadeSelect
                                popoverWidth={600}
                                withinPortal
                                multiple
                                searchable
                                allSelected
                                selectionMode="auto-leaf"
                                options={options}
                            />
                        </Unit>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <Unit title="单选可搜索, 只能选择最终层级">
                            <CascadeSelect
                                popoverWidth={600}
                                withinPortal
                                allSelected
                                selectionMode="auto-leaf"
                                searchable
                                options={options}
                            />
                        </Unit>
                        <Unit title="多选可搜索, 只能选择最终层级">
                            <CascadeSelect
                                popoverWidth={600}
                                withinPortal
                                multiple
                                searchable
                                allSelected
                                selectionMode="leaf-only"
                                options={options}
                            />
                        </Unit>
                    </Grid.Col>
                </Grid>
            </Group>
        </Card>
    )
}
